import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ErrorCode} from '../enums/error-codes';
import {User} from '../entities/user/user';
import {UserService} from './user.service';
import {Pagination} from '../entities/pagination';
import {Sorting} from '../entities/sorting';
import {ActivatedRoute} from '@angular/router';
import {Subject, Subscription} from 'rxjs';
import {GroupType} from '../enums/group-type.enum';
import {ModalComponent} from 'ng2-bs3-modal/components/modal';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BusinessType} from '../enums/business-type';
import {CountryService} from '../country.service';
import {OrderDirection} from '../enums/order-direction';
import {AdvancedSearch} from '../entities/advanced-search';
import {Filter} from '../entities/filter';

declare var $: any;

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class UsersComponent implements OnInit {
cCodes = {
                    AF: 'Afghanistan',
                    AX: 'Åland Islands',
                    AL: 'Albania',
                    DZ: 'Algeria',
                    AS: 'American Samoa',
                    AD: 'Andorra',
                    AO: 'Angola',
                    AI: 'Anguilla',
                    AQ: 'Antarctica',
                    AG: 'Antigua and Barbuda',
                    AR: 'Argentina',
                    AM: 'Armenia',
                    AW: 'Aruba',
                    AU: 'Australia',
                    AT: 'Austria',
                    AZ: 'Azerbaijan',
                    BS: 'Bahamas',
                    BH: 'Bahrain',
                    BD: 'Bangladesh',
                    BB: 'Barbados',
                    BY: 'Belarus',
                    BE: 'Belgium',
                    BZ: 'Belize',
                    BJ: 'Benin',
                    BM: 'Bermuda',
                    BT: 'Bhutan',
                    BO: 'Bolivia, Plurinational State of',
                    BQ: 'Bonaire, Sint Eustatius and Saba',
                    BA: 'Bosnia and Herzegovina',
                    BW: 'Botswana',
                    BV: 'Bouvet Island',
                    BR: 'Brazil',
                    IO: 'British Indian Ocean Territory',
                    BN: 'Brunei Darussalam',
                    BG: 'Bulgaria',
                    BF: 'Burkina Faso',
                    BI: 'Burundi',
                    KH: 'Cambodia',
                    CM: 'Cameroon',
                    CA: 'Canada',
                    CV: 'Cape Verde',
                    KY: 'Cayman Islands',
                    CF: 'Central African Republic',
                    TD: 'Chad',
                    CL: 'Chile',
                    CN: 'China',
                    CX: 'Christmas Island',
                    CC: 'Cocos (Keeling) Islands',
                    CO: 'Colombia',
                    KM: 'Comoros',
                    CG: 'Congo',
                    CD: 'The Democratic Republic of the Congo',
                    CK: 'Cook Islands',
                    CR: 'Costa Rica',
                    CI: 'Côte d\'Ivoire',
                    HR: 'Croatia',
                    CU: 'Cuba',
                    CW: 'Curaçao',
                    CY: 'Cyprus',
                    CZ: 'Czech Republic',
                    DK: 'Denmark',
                    DJ: 'Djibouti',
                    DM: 'Dominica',
                    DO: 'Dominican Republic',
                    EC: 'Ecuador',
                    EG: 'Egypt',
                    SV: 'El Salvador',
                    GQ: 'Equatorial Guinea',
                    ER: 'Eritrea',
                    EE: 'Estonia',
                    ET: 'Ethiopia',
                    FK: 'Falkland Islands (Malvinas)',
                    FO: 'Faroe Islands',
                    FJ: 'Fiji',
                    FI: 'Finland',
                    FR: 'France',
                    GF: 'French Guiana',
                    PF: 'French Polynesia',
                    TF: 'French Southern Territories',
                    GA: 'Gabon',
                    GM: 'Gambia',
                    GE: 'Georgia',
                    DE: 'Germany',
                    GH: 'Ghana',
                    GI: 'Gibraltar',
                    GR: 'Greece',
                    GL: 'Greenland',
                    GD: 'Grenada',
                    GP: 'Guadeloupe',
                    GU: 'Guam',
                    GT: 'Guatemala',
                    GG: 'Guernsey',
                    GN: 'Guinea',
                    GW: 'Guinea-Bissau',
                    GY: 'Guyana',
                    HT: 'Haiti',
                    HM: 'Heard Island and McDonald Islands',
                    VA: 'Holy See (Vatican City State)',
                    HN: 'Honduras',
                    HK: 'Hong Kong',
                    HU: 'Hungary',
                    IS: 'Iceland',
                    IN: 'India',
                    ID: 'Indonesia',
                    IR: 'Islamic Republic of Iran',
                    IQ: 'Iraq',
                    IE: 'Ireland',
                    IM: 'Isle of Man',
                    IL: 'Israel',
                    IT: 'Italy',
                    JM: 'Jamaica',
                    JP: 'Japan',
                    JE: 'Jersey',
                    JO: 'Jordan',
                    KZ: 'Kazakhstan',
                    KE: 'Kenya',
                    KI: 'Kiribati',
                    KP: 'Democratic People\'s Republic of Korea',
                    KR: 'Republic of Korea',
                    KW: 'Kuwait',
                    KG: 'Kyrgyzstan',
                    LA: 'Lao People\'s Democratic Republic',
                    LV: 'Latvia',
                    LB: 'Lebanon',
                    LS: 'Lesotho',
                    LR: 'Liberia',
                    LY: 'Libya',
                    LI: 'Liechtenstein',
                    LT: 'Lithuania',
                    LU: 'Luxembourg',
                    MO: 'Macao',
                    MK: 'The former Yugoslav Republic of Macedonia',
                    MG: 'Madagascar',
                    MW: 'Malawi',
                    MY: 'Malaysia',
                    MV: 'Maldives',
                    ML: 'Mali',
                    MT: 'Malta',
                    MH: 'Marshall Islands',
                    MQ: 'Martinique',
                    MR: 'Mauritania',
                    MU: 'Mauritius',
                    YT: 'Mayotte',
                    MX: 'Mexico',
                    FM: 'Micronesia, Federated States of',
                    MD: 'Republic of Moldova',
                    MC: 'Monaco',
                    MN: 'Mongolia',
                    ME: 'Montenegro',
                    MS: 'Montserrat',
                    MA: 'Morocco',
                    MZ: 'Mozambique',
                    MM: 'Myanmar',
                    NA: 'Namibia',
                    NR: 'Nauru',
                    NP: 'Nepal',
                    NL: 'Netherlands',
                    NC: 'New Caledonia',
                    NZ: 'New Zealand',
                    NI: 'Nicaragua',
                    NE: 'Niger',
                    NG: 'Nigeria',
                    NU: 'Niue',
                    NF: 'Norfolk Island',
                    MP: 'Northern Mariana Islands',
                    NO: 'Norway',
                    OM: 'Oman',
                    PK: 'Pakistan',
                    PW: 'Palau',
                    PS: 'Palestinian Territory, Occupied',
                    PA: 'Panama',
                    PG: 'Papua New Guinea',
                    PY: 'Paraguay',
                    PE: 'Peru',
                    PH: 'Philippines',
                    PN: 'Pitcairn',
                    PL: 'Poland',
                    PT: 'Portugal',
                    PR: 'Puerto Rico',
                    QA: 'Qatar',
                    RE: 'Réunion',
                    RO: 'Romania',
                    RU: 'Russian Federation',
                    RW: 'Rwanda',
                    BL: 'Saint Barthélemy',
                    SH: 'Saint Helena, Ascension and Tristan da Cunha',
                    KN: 'Saint Kitts and Nevis',
                    LC: 'Saint Lucia',
                    MF: 'Saint Martin (French part)',
                    PM: 'Saint Pierre and Miquelon',
                    VC: 'Saint Vincent and the Grenadines',
                    WS: 'Samoa',
                    SM: 'San Marino',
                    ST: 'Sao Tome and Principe',
                    SA: 'Saudi Arabia',
                    SN: 'Senegal',
                    RS: 'Serbia',
                    SC: 'Seychelles',
                    SL: 'Sierra Leone',
                    SG: 'Singapore',
                    SX: 'Sint Maarten (Dutch part)',
                    SK: 'Slovakia',
                    SI: 'Slovenia',
                    SB: 'Solomon Islands',
                    SO: 'Somalia',
                    ZA: 'South Africa',
                    GS: 'South Georgia and the South Sandwich Islands',
                    SS: 'South Sudan',
                    ES: 'Spain',
                    LK: 'Sri Lanka',
                    SD: 'Sudan',
                    SR: 'Suriname',
                    SJ: 'Svalbard and Jan Mayen',
                    SZ: 'Swaziland',
                    SE: 'Sweden',
                    CH: 'Switzerland',
                    SY: 'Syrian Arab Republic',
                    TW: 'Taiwan, Province of China',
                    TJ: 'Tajikistan',
                    TZ: 'United Republic of Tanzania',
                    TH: 'Thailand',
                    TL: 'Timor-Leste',
                    TG: 'Togo',
                    TK: 'Tokelau',
                    TO: 'Tonga',
                    TT: 'Trinidad and Tobago',
                    TN: 'Tunisia',
                    TR: 'Turkey',
                    TM: 'Turkmenistan',
                    TC: 'Turks and Caicos Islands',
                    TV: 'Tuvalu',
                    UG: 'Uganda',
                    UA: 'Ukraine',
                    AE: 'United Arab Emirates',
                    GB: 'United Kingdom',
                    US: 'United States',
                    UM: 'United States Minor Outlying Islands',
                    UY: 'Uruguay',
                    UZ: 'Uzbekistan',
                    VU: 'Vanuatu',
                    VE: 'Bolivarian Republic of Venezuela',
                    VN: 'Viet Nam',
                    VG: 'Virgin Islands, British',
                    VI: 'Virgin Islands, U.S.',
                    WF: 'Wallis and Futuna',
                    EH: 'Western Sahara',
                    YE: 'Yemen',
                    ZM: 'Zambia',
                    ZW: 'Zimbabwe',
    };

    public errorTitle: any = false;
    isLoading = true;
    isAdvancedSearchActivated = false;
    advancedSearch: AdvancedSearch = new AdvancedSearch();
    errCode = '';
    errorFromServer = ErrorCode.Success;
    pagination: Pagination;
    sorting: Sorting;
    curP;
    pP;
    sorti;
    sortOrder: OrderDirection;
    users: User[];
    countries: any[] = [];
    selectedUsers: number[];
    groupTypes = GroupType;
    @ViewChild('modal') modal: ModalComponent;
    @ViewChild('modalNew') modalNew: ModalComponent;
    @ViewChild('modalDelete') modalDelete: ModalComponent;
    @ViewChild('modalBulkEdit') modalBulkEdit: ModalComponent;
    @ViewChild('modalBulkBan') modalBulkBan: ModalComponent;
    @ViewChild('modalFilter') modalFilter: ModalComponent;
    editingUser: any;
    openFilter: any = {};
    activeFilters: any = {};
    saveUserProgress: boolean;
    newUser: User = new User();
    form: FormGroup;
    businessTypes = BusinessType;
    displayPocSelection = false;
    pocUsers: User[];
    headerFields: any[] = [
        {
            'title': 'User\'s details',
            'value': 'full_name',
            'filter_title': 'User role',
            'filter_value': 'group_id',
            'filterable': true,
            'sortable': true
        },
        {
            'title': 'Phone',
            'sortable': true,
            'filterable': false,
            'value': 'phone'
        },
        {
            'title': 'Email',
            'sortable': true,
            'filterable': false,
            'value': 'email'
        },
        {
            'title': 'Company',
            'sortable': true,
            'filterable': true,
            'filter_value': 'company',
            'value': 'company'
        },
        {
            'title': 'Markup',
            'sortable': true,
            'filterable': true,
            'filter_value': 'markup',
            'value': 'markup'
        },
        {
            'title': 'Country',
            'value': 'country',
            'filterable': true,
            'filter_value': 'country',
            'sortable': false
        },
        {
            'title': 'Manager',
            'sortable': true,
            'filterable': true,
            'filter_value': 'name',
            'value': 'manager'
        },
        {
            'title': 'Registered at',
            'sortable': true,
            'filterable': false,
            'value': 'created_at'
        },
        {
            'title': 'Last Login',
            'sortable': true,
            'filterable': false,
            'value': 'changed_date'
        }
    ];
    search = '';
    private _searchStrem = new Subject<string>();
    private _countries: any[];
    public serverErrors = {
                                      '1000': 'Invalid method',
                                      '1002': 'DB connection failed',
                                      '1001': 'Not authorized',
                                      '1004': 'Deprecated',
                                      '1005': 'Headers missing',
                                      '1010': 'Bad request',
                                      '1020': 'General error',
                                      '1030': 'Fields missing',
                                      '1031': 'Bad enum',
                                      '2000': 'Email length invalid',
                                      '2001': 'Email format invalid',
                                      '2010': 'User doesn\'t exist',
                                      '2020': 'User blocked',
                                      '2030': 'Password doesn\'t match',
                                      '2040': 'Password length invalid',
                                      '2050': 'Email is already taken',
                                      '2060': 'First name length invalid',
                                      '2061': 'Last name length invalid',
                                      '2070': 'Company name length invalid',
                                      '2080': 'Phone prefix doesn\'t exists',
                                      '2081': 'Country code doesn\'t exists',
                                      '2090': 'Forgot password doesn\'t exists',
                                      '2091': 'Forgot password expired',
                                      '2100': 'POC not found',
                                      '3000': 'Invalid CSV file',
                                      '4000': 'Search Search not found',
                                      '4001': 'Search doesn\'t belong to user',
                                      '5000': 'Message not found',
                                      '6000': 'Collection not found',
                                      '7000': 'Same position as before',
                                      '8000': 'Attribute not found',
                                      '10000': 'Uploaded file is too large',
                                      '10010': 'Uplaoded file is not an image',
                                      '10011': 'Uploaded file type is invalid',
                                      '10020': 'File is not an image'
                                    };

    private _subscription: Subscription;
    passwordConf: any;

    constructor(private _userService: UserService,
                private route: ActivatedRoute,
                private _builder: FormBuilder,
                private _countryService: CountryService) {
        this.editingUser = new User;
        this.sortOrder = new OrderDirection(true);
        for (const key in this.cCodes) {
            this.countries.push({
                'id': key,
                'text': this.cCodes[key]
            });
        }
        this.sorting = new Sorting();
    }

    private getUsersAccordingToParams() {
        this._subscription = this.route
            .queryParams
            .subscribe(params => {
                const currentPage = +params['page'] || 0;
                const resultsPerPage = +params['results-per-page'] || 25;
                this.search = <string>params['search'];

                this.curP = currentPage;
                this.pP = resultsPerPage;
                this.sorti = this.sorting;
                this.loadUsers(currentPage, resultsPerPage, this.sorting, this.search, this.advancedSearch);
            });
    }

    private loadUsers(currentPage: number, resultsPerPage: number, sorting: Sorting, search: string, advancedSearch: AdvancedSearch) {
        this.isLoading = true;
        this._userService.getUsers(currentPage, resultsPerPage, sorting, search, advancedSearch, this.getSelectedFilters())
            .subscribe(
                response => {
                    this.errorFromServer = response.error;
                    this.pagination = response.pagination;
                    // this.sorting = response.sorting;
                    this.users = response.users;
                    this.selectedUsers = [];
                    this.prepareFilters(response.filter);
                },
                null,
                () => this.isLoading = false
            );
    }

    protected prepareFilters(data: any) {
        for (const k in this.headerFields) {
            const headerField = this.headerFields[k];
            if (!headerField['filterable']) {
                continue;
            }
            const selectedFilters = this.getSelectedFilters();
            const field = headerField.filter_value;
            if (data.hasOwnProperty(field)) {
                const selectedFilter = selectedFilters[field] ? selectedFilters[field] : [];
                this.activeFilters[field] = [];
                if (field === 'name') {
                    const filter = new Filter;
                    filter.value = '';
                    filter.title = '-';
                    filter.checked = selectedFilter.includes('');
                    this.activeFilters[field].push(filter);
                }
                data[field].forEach((el) => {
                    if (el == null) {
                        return;
                    }
                    const filter = new Filter;
                    filter.value = el;
                    if (field === 'group_id') {
                        switch (+el) {
                            case GroupType.Guest:
                                filter.title = 'Guest';
                                break;
                            case GroupType.Client:
                                filter.title = 'Client';
                                break;
                            case GroupType.Collaborator:
                                filter.title = 'Collaborator';
                                break;
                            case GroupType.FullManager:
                                filter.title = 'FullManager';
                                break;
                            case GroupType.Manager:
                                filter.title = 'Manager';
                                break;
                            case GroupType.Viewer:
                                filter.title = 'Viewer';
                                break;
                        }
                    } else if (field === 'country') {
                        filter.title = this.cCodes[el] ? this.cCodes[el] : el;
                    } else {
                        filter.title = el;
                    }
                    filter.checked = selectedFilter.includes(el);
                    this.activeFilters[field].push(filter);
                });
            }
        }
    }

    private buildForm() {
        this.form = this._builder.group({
            role: [
                ''
            ],
            poc: [
                ''
            ],
            defaultMarkup: [
                ''
            ]
        });
    }

    private getCountriesList() {
        this._countryService.getCountries()
            .subscribe(countries => {
                this._countries = countries;
            });
    }

    private getPocList() {
        this._userService.getPocList()
            .subscribe(response => {
                this.pocUsers = response.users;
            });
    }

    ngOnInit(init ?: any) {
        this.getUsersAccordingToParams();
        this.buildForm();
        this.getCountriesList();
        this.getPocList();
        this.selectedUsers = [];
        this._searchStrem
            .debounceTime(1000)
            .distinctUntilChanged()
            .subscribe(search => {
                this.loadUsers(1, this.pagination.results_per_page, this.sorting, search, this.advancedSearch);
            });
        this.modalFilter.onOpen.subscribe( () => {
            this.isLoading = false;
        });
        this.modalFilter.onDismiss.subscribe( () => {
            this.isLoading = false;
        });
    }




  changePrefix() {
    this.newUser.phone_prefix = $('#regPhoneCode').intlTelInput('getSelectedCountryData').dialCode;
  }

  togglePrefixSelect(event: any){
    setTimeout(function(){
      $('.selected-flag').trigger('click');
    }, 100);
  }

  setCountry(model: any){
    $('#regPhoneCode').intlTelInput('setCountry', model);
  }


    groupTypeChange() {
        const usersGroup = this.editingUser.permissions.group_id;

        this.displayPocSelection = usersGroup == GroupType.Client || usersGroup == GroupType.Collaborator || usersGroup == GroupType.Viewer;
    }

    openEditModal(user: User) {
        this.editingUser = <User>JSON.parse(JSON.stringify(user));
        this.groupTypeChange();

        if (!this.editingUser.poc) {
            this.editingUser.poc = new User;
        }

        const usersCountry = this.editingUser.country.toUpperCase();
        for (const country of this._countries) {
            if (country.code == usersCountry) {
                this.editingUser.country = country.name;
                break;
            }
        }

        this.modal.open();
    }

    openNewModal(user?: any) {
      this.newUser = new User();
      this.modalNew.open();
    }

    saveUser(form?: any) {
        /*if(this.editingUser.permissions.group_id == '0' || this.editingUser.permissions.group_id == '4' || this.editingUser.permissions.group_id == '5') {
            this.editingUser.poc = null;
        }*/
        this._userService.editUser(this.editingUser)
            .subscribe((res) => {
                this.users.forEach((el, i) => {
                    if (el.id == res.user.id) {
                        this.users[i] = res.user;
                    }
                } );
            });

        this.users.forEach((user, index) => {
            if (user.id == this.editingUser.id) {
                this.users[index] = this.editingUser;
                return;
            }
        });

        this.modal.close();
    }

    saveNewUser(form: any) {
        this.errorTitle = false;
        this.errCode = '';
        if (form.form.invalid){
          return;
        }

        this.saveUserProgress = true;
        this._userService.createUser(this.newUser).subscribe((res) => {
            if (res.error_code != 0) {
                this.errCode = res.error_code || res.error;
            }else{
                this.modalNew.close();
                this.loadUsers(1, this.pagination.results_per_page, this.sorting, this.search, this.advancedSearch);
            }

            this.saveUserProgress = false;
        });
/*            .then((res) => {
                console.log(res);
            }, (err) => {
                console.log(err);
            });*/
/*this.modalNew.close();
        this.getService.signUp(this.newUser).then((res: any) => {

            if(res.error_code == 0) {

              if(res.authorization_token != '') {
                this.authService.login(res.authorization_token, true);
                this.router.navigate(['/search'], {});
              }else{
                this.appMemory.newUserEvent.next('newUser')
              }
            }else{
              this.errorTitle = this.errors[res.error_code];

            }

        }, (err: any) => {
        })*/

    }

    private updateUsersListBlockStatus() {
        this.users[this.getUserArrayIndexById(this.editingUser.id)].blocked = this.editingUser.blocked;
    }

    private getUserArrayIndexById(userId: number) {
        let index: number;

        this.users.forEach((user, i) => {
            if (user.id == userId) {
                index = i;
                return;
            }
        });

        return index;
    }

    blockUser() {
        this.editingUser.blocked = true;
        this.updateUsersListBlockStatus();

        this._userService.blockUser(this.editingUser.id)
            .subscribe();
    }

    unblockUser() {
        this.editingUser.blocked = false;
        this.updateUsersListBlockStatus();

        this._userService.unblockUser(this.editingUser.id)
            .subscribe();
    }

    deleteUser() {
        if (confirm('Are you sure you would like to delete ' + this.editingUser.first_name + '?')) {
            const index = this.getUserArrayIndexById(this.editingUser.id);
            this.users.splice(index, 1);

            this.pagination.results_current_page--;
            this.pagination.total_results--;
            this._userService.deleteUser(this.editingUser.id)
                .subscribe();

            this.modal.close();
        }
    }

    performSearch(search) {
        this.search = search;
        this._searchStrem.next(search);
    }

    performAdvancedSearch() {
        this.loadUsers(1, this.pagination.results_per_page, this.sorting, '', this.advancedSearch);
    }

    onCheckboxChange(id: number, $event) {
        if ($event.target.checked) {
            this.selectedUsers.push(id);
        } else {
            const idx = this.selectedUsers.indexOf(id);
            if (idx > -1) {
                this.selectedUsers.splice(idx, 1);
            }
        }
    }

    toggleAll($event) {
        const isChecked = $event.target.checked;
        $('.container :checkbox[name="selected_users"]').prop('checked', isChecked);
        if (isChecked) {
            $('.container :checkbox[name="selected_users"]').each((_, el) => {
                this.selectedUsers.push(+$(el).val());
            });
        } else {
            this.selectedUsers = [];
        }
    }

    openDeleteModal() {
        this.modalDelete.open();
    }

    deleteUsers() {
        if (confirm('Are you sure you want to Delete ' + this.selectedUsers.length +  ' users?')) {
            this.isLoading = true;
            this._userService.bulkDeleteUsers(this.selectedUsers).subscribe((res) => {
                this.users = this.users.filter((user, i) => {
                    return this.selectedUsers.indexOf(user.id) === -1;
                });
                this.selectedUsers = [];
                this.isLoading = false;
                this.modalDelete.close();
            });
        }
    }

    openBulkEditModal() {
        this.editingUser = new User();
        this.editingUser.poc = new User;
        this.editingUser.permissions.group_id = GroupType.Guest;
        this.groupTypeChange();
        this.modalBulkEdit.open();
    }

    openBulkBanModal() {
        this.modalBulkBan.open();
    }

    bulkEditUsers() {
        this.isLoading = true;
        this._userService.bulkEditUsers(this.selectedUsers, this.editingUser).subscribe((response) => {
            this.updateUsersFromResponse(response.users);
            this.selectedUsers = [];
            this.isLoading = false;
            this.modalBulkEdit.close();
        });
    }

    private updateUsersFromResponse(users: any[]) {
        if (users.length > 0) {
            users.forEach((updatedUser) => {
                this.users.forEach((user, i) => {
                    if (user.id === updatedUser.id) {
                        this.users[i] = updatedUser;
                    }
                });
            });
        }
    }

    bulkBlockUsers() {
        if (confirm('Are you sure you want to Block ' + this.selectedUsers.length +  ' users?')) {
            this.isLoading = true;
            this._userService.bulkBlockUsers(this.selectedUsers).subscribe((res) => {
                this.updateUsersFromResponse(res.users);
                this.selectedUsers = [];
                this.isLoading = false;
                this.modalBulkBan.close();
            });
        }
    }

    bulkUnblockUsers() {
        if (confirm('Are you sure you want to Unblock ' + this.selectedUsers.length +  ' users?')) {
            this.isLoading = true;
            this._userService.bulkUnblockUsers(this.selectedUsers).subscribe((res) => {
                this.updateUsersFromResponse(res.users);
                this.selectedUsers = [];
                this.isLoading = false;
                this.modalBulkBan.close();
            });
        }
    }

    toggleClick(field: any) {
        if (field.value !== this.sorting.by) {
            this.sorting.by = field.value;
            this.sorting.direction = this.sortOrder.updateOrder(true).toString();
        } else {
            this.sorting.direction = this.sortOrder.updateOrder(!this.sortOrder.value).toString();
        }
        this.loadUsers(this.curP, this.pP, this.sorting, this.search, this.advancedSearch);
        return false;
    }

    toggleAdvancedSearch() {
        this.isAdvancedSearchActivated = !this.isAdvancedSearchActivated;
    }

    exportExcel() {
        this._userService.exportExcel(this.selectedUsers);
    }

    public refreshValue(value: any): void {
        this.advancedSearch.country = value;
    }

    openFilterModal(value: any) {
        this.openFilter = value;
        this.isLoading = true;
        this.modalFilter.open();
    }

    toggleFilterSelection(event) {
       this.activeFilters[this.openFilter.filter_value].forEach((el) => {
           el.checked = event.target.checked;
       });
    }
    checkedFilter(name: string): any[] {
        if (!this.activeFilters[name]) {
            return [];
        }
        return this.activeFilters[name].filter((elem) => {
            return elem.checked;
        });
    }
    getSelectedFilters() {
        const selectedFilters = {};
        for (const k in this.activeFilters) {
            selectedFilters[k] = this.checkedFilter(k).map((elem) => {
                return elem.value;
            });
        }
        return selectedFilters;
    }
    getPaginationParams() {
        const params = {
            'search': this.search
        };
        params['sorting[by]'] = this.sorting.by;
        params['sorting[direction]'] = this.sorting.direction;
        const filters = this.getSelectedFilters();
        for (const k in filters) {
            params['filter[' + k + '][]'] = filters[k].join('&filter[' + k + '][]=');
        }
        for (const k in this.advancedSearch) {
            if (k === 'country') {
                params['advanced_search[' + k + '][]'] = filters[k].join('&advanced_search[' + k + '][]=');
            } else {
                params['advanced_search[' + k + ']'] = filters[k];
            }
        }
        return params;
    }

    clearSearchConditions() {
        this.search = '';
        this.advancedSearch = new AdvancedSearch();
        this.activeFilters = {};
        this.loadUsers(1, this.pagination.results_per_page, this.sorting, this.search, this.advancedSearch);
    }

    applyAllFilters() {
        this.isLoading = true;
        this.modalFilter.close();
        this.loadUsers(1, this.pagination.results_per_page, this.sorting, this.search, this.advancedSearch);
    }
}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts